import React from 'react';
import block from 'bem-cn';
import { shallowEqual, useSelector } from 'react-redux';

import Switcher from 'components/Switcher';
import SVG from 'components/SVG';
import AssistantBack from '../AssistantBack';
import crossSVG from 'shared/img/cross-bold.svg';

import './AssistantHeader.scss';

const b = block('assistant-header');

const AssistantHeader = ({ model }) => {
  const { assistantPanel: assistantLocale } = useSelector(state => state.locale.locale, shallowEqual);
  const {
    inputState: { values, handleChangeStructure, closeAssistant },
    outputState: { isBackButtonActive },
  } = model;

  return (
    <header className={b()}>
      {isBackButtonActive && (
        <div className={b('back-button')}>
          <AssistantBack model={model} />
        </div>
      )}
      <div className={b('switchers')}>
        <label className={b('switcher')}>
          <div className={b('switcher-element')}>
            <Switcher isActive={values?.isDirect} onSwitch={() => handleChangeStructure(true)} />
          </div>
          <span className={b('switcher-label')}>{assistantLocale?.direct}</span>
        </label>
        <label className={b('switcher')}>
          <div className={b('switcher-element')}>
            <Switcher isActive={values?.isFullStructure} onSwitch={() => handleChangeStructure()} />
          </div>
          <span className={b('switcher-label')}>{assistantLocale?.entire}</span>
        </label>
      </div>
      <SVG className={b('cross')} svgProps={{ svg: crossSVG }} onClick={closeAssistant} />
    </header>
  );
};

export default AssistantHeader;
